export default __webpack_public_path__ + "static/media/recovered.e0cb1d11.svg";